/*
  EasyPoints を Dawn のカート更新に追随させる。

  配布 JS はページ読み込み時に一度だけ EasyPoints.Register.run() を呼び、
  サーバーが描画したプレースホルダー "-" を実際のポイント数へ差し替える。
  Dawn は数量変更や商品削除のたびに Section Rendering API でカートを描き直すため、
  差し替え前の "-" が戻ったまま JS が再実行されず、獲得ポイントが "-" のままになる。

  配布 JS 側の cartopenObserver は Parallax のドロワー (.side-cart-position--right)
  を監視しているので Dawn では何も拾わない。そのぶんをここで補う。

  配布ファイルはアプリ更新で上書きされるため、ブリッジはこのファイルに置く。
*/

(function () {
  function refreshEasyPoints() {
    if (typeof EasyPoints === "undefined" || !EasyPoints.Register) {
      return;
    }

    try {
      EasyPoints.Register.run();
    } catch (error) {
      // ポイント表示が古いままになるだけで、カート操作自体は続行させる
      if (window.console && console.warn) {
        console.warn("[EasyPoints] refresh after cart update failed", error);
      }
    }
  }

  // Dawn はカート更新後に cartUpdate を publish する。
  // セクションの差し替えが終わってから読むために 1 フレーム遅らせる。
  function scheduleRefresh() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(refreshEasyPoints);
    });
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    subscribe(PUB_SUB_EVENTS.quantityUpdate, scheduleRefresh);
  }

  // ドロワーの開閉でも中身が差し替わることがあるため、開いた時点でも一度走らせる。
  document.addEventListener("click", function (event) {
    if (event.target.closest && event.target.closest("#cart-icon-bubble")) {
      scheduleRefresh();
    }
  });
})();
